<template>
    <div>
        <div v-if="!initialized && busy"><i class="icon-spinner2 spinner"></i></div>
        <div v-else-if="product">
            <ValidationObserver ref="productform">
                <form @submit.prevent="saveProduct">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-8">
                                    <ValidationProvider vid="ProdName" name="Namn (Intern+Lapp)" rules="required" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Namn (Intern+Lapp) <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" v-model="product.ProdName" v-bind:class="{ 'border-danger':errors[0] }">
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-lg-4">
                                    <SelectWithValidation
                                        label="Varumärke"
                                        component="brand-filter"
                                        v-model="product.brand_id"
                                        :reduce="(opt) => opt.id"
                                    ></SelectWithValidation>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-xl-4">
                                    <ValidationProvider vid="ProdSupplierID" name="Leverantör" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Leverantör</label>
                                            <supplier-filter
                                                v-model="product.ProdSupplierID"
                                                placeholder="-- Välj leverantör --"
                                                :reduce="opt => opt.id"
                                            ></supplier-filter>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-xl-4">
                                    <ValidationProvider vid="ProdSupplierSKU" name="Lev. artikelnr" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Lev. artikelnr</label>
                                            <input type="text" class="form-control" v-model="product.ProdSupplierSKU" :class="{ 'border-danger':errors[0] }">
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-xl-4">
                                    <ValidationProvider vid="SupplierPackageSize" name="Förpackningsstorlek" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Förpackningsstorlek</label>
                                            <input type="number" step="1" class="form-control" v-model="product.SupplierPackageSize" :class="{ 'border-danger':errors[0] }">
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-4">
                                    <ValidationProvider tag="div" class="form-group" vid="CustomsSourceCountryCode" name="Ursprungsland" v-slot="{ errors }">
                                        <label>Ursprungsland</label>
                                        <country-filter
                                            :reduce="(opt) => opt.id"
                                            v-model="product.CustomsSourceCountryCode"
                                        ></country-filter>
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                                <div class="col-xl-4">
                                    <ValidationProvider tag="div" class="form-group" vid="CustomsStatNo" name="Tulltariffkod, Export (8-siffror)" :rules="{ length: 8 }" v-slot="{ errors }">
                                        <label>Tulltariffkod, Export (8-siffror)</label>
                                        <input type="text" class="form-control" v-model="product.CustomsStatNo" :class="{ 'border-danger': errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                    <div v-if="product.customs_commodity_code" class="font-size-xs text-muted" style="font-size: 9px;"
                                         v-html="(product.customs_commodity_code.full_description_se || product.customs_commodity_code.description_se)"></div>
                                </div>
                                <div class="col-xl-4">
                                    <ValidationProvider tag="div" class="form-group" vid="ProdWeight" name="Produktvikt" v-slot="{ errors }">
                                        <label>Produktvikt</label>
                                        <div class="input-group">
                                            <input type="number" class="form-control" v-model="product.ProdWeight" min="0" step="0.001" :class="{ 'border-danger': errors[0] }">
                                            <span class="input-group-append"><span class="input-group-text">kg</span></span>
                                        </div>
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <ValidationProvider tag="div" class="form-group" vid="ProdSupplierInfo" name="Beskrivning" rules="" v-slot="{ errors }">
                                <label>Leverantörens beskrivning</label>
                                <elastic-textarea class="form-control" v-model="product.ProdSupplierInfo" style="min-height: 332px;"></elastic-textarea>
                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col-lg-6">
                            <ValidationProvider tag="div" class="form-group" vid="internalNotes" name="Interna noteringar" rules="" v-slot="{ errors }">
                                <label>Interna noteringar</label>
                                <elastic-textarea class="form-control" v-model="product.internalNotes" style="min-height: 500px;"></elastic-textarea>
                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                            </ValidationProvider>

                            <file-list-uploader
                                class="mb-3"
                                model-type="products"
                                :model-id="id"
                                :extensions="['jpg','jpeg','png','pdf','mp4','doc','docx','xls','xlsx']"
                                :accept="'image/png,image/jpeg,application/pdf,video/mp4,' +
                                    'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
                                    'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                                multiple
                                auto-start-upload
                                display-list
                                header="Filer/dokument"
                            ></file-list-uploader>
                        </div>
                    </div>
                </form>
            </ValidationObserver>

            <div class="d-flex justify-content-between">
                <limitless-button ref="btncopyproduct" btn-class="btn-light" type="button" @click="showCopyProductForm" :busy="busy_copy" icon="icon-copy4">Kopiera produkt</limitless-button>
                <limitless-button ref="btnsaveproduct" type="button" @click="saveProduct" :busy="busy" icon="icon-floppy-disk">SPARA</limitless-button>
            </div>
        </div>
        <div v-else class="text-danger">Kunde ej hämta data...</div>

        <b-modal
            id="modal_copy_product"
            title="Kopiera produkt"
            key="modal_copy_product"
            ok-title="Skapa"
            ok-variant="primary"
            @ok="copyProduct"
            cancel-variant="light"
            cancel-title="Avbryt"
        >
            <ValidationObserver ref="productform">
                <form @submit.prevent="copyProduct">
                    <ValidationProvider vid="ProdID" name="Produkt ID" rules="required" v-slot="{ errors }">
                        <div class="mb-2">
                            <label>Produkt ID <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="newproduct.ProdID" v-bind:class="{ 'border-danger':errors[0] }">
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider vid="ProdName" name="Namn (Intern+Lapp)" rules="required" v-slot="{ errors }">
                        <div class="mb-2">
                            <label>Namn (Intern+Lapp) <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="newproduct.ProdName" v-bind:class="{ 'border-danger':errors[0] }">
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </form>
            </ValidationObserver>
        </b-modal>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import SupplierFilter from '@components/Filters/SupplierFilter';
import ElasticTextarea from '@components/ElasticTextarea';
import CountryFilter from '@components/Filters/CountryFilter.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import FileListUploader from '@components/Form/FileListUploader.vue';

export default {
    name: 'ProductEditorInfo',
    components: {
        FileListUploader,
        SelectWithValidation,
        CountryFilter,
        ElasticTextarea,
        SupplierFilter,
        LimitlessButton,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy: true,
        busy_copy: false,
        product: null,
        newproduct: {
            ProdID: '',
            ProdName: '',
        },
    }),
    mounted() {
        this.getProduct();
    },
    methods: {
        getProduct() {
            apiClient.get('/vue/products/' + this.id + '/info')
                .then((response) => {
                    this.product = response.data.product;
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy = false;
                });
        },
        async saveProduct() {
            const isValid = await this.$refs.productform.validate();
            if (isValid) {
                this.busy = true;
                await apiClient.post('/vue/products/' + this.id + '/info', this.product)
                    .then((response) => {
                        if (parseInt(this.id, 10) !== response.data.product.ProdID) {
                            window.location.href = '/products/' + response.data.product.ProdID;
                        }
                        this.product = response.data.product;
                        this.$refs.btnsaveproduct.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.productform.setErrors(parsederror);
                        }
                        this.$refs.btnsaveproduct.triggerFailed();
                    })
                    .finally(() => {
                        this.busy = false;
                    });
            }
        },
        showCopyProductForm() {
            this.newproduct.ProdName = this.product.ProdName + ' (kopia)';
            this.getNextProdID();
            this.$root.$bvModal.show('modal_copy_product');
        },
        async copyProduct(e) {
            e.preventDefault();
            this.busy_copy = true;
            await apiClient.post('/vue/products/' + this.id + '/copy', this.newproduct)
                .then((response) => {
                    if (response.data.prod_id) {
                        window.location.href = '/products/' + response.data.prod_id;
                    }
                })
                .finally(() => {
                    this.busy_copy = false;
                });
        },
        async getNextProdID() {
            await apiClient.post('/vue/products/next')
                .then((response) => {
                    this.newproduct.ProdID = response.data.ProdID;
                })
                .catch(() => {
                    this.newproduct.ProdID = '';
                });
        },
    },
};

</script>

<style scoped>
.prod-icons-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.prod-icons-grid .prod-icon {
    margin: 0 5px 5px 0;
}
.prod-icons-grid .prod-icon  .custom-control-label {
    width: 120px;
    height: 130px;
    margin: 0;
    padding: 10px 10px 20px 10px;
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    border-radius: 4px;
}
.prod-icons-grid .prod-icon  .custom-control-label .inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}
.prod-icons-grid .prod-icon  .custom-control-label .inner .icon {
    display: block;
    width: 100%;
    height: 43px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
}
.prod-icons-grid .prod-icon  .custom-control-label:before {
    top: auto;
    bottom: 10px;
    left: calc(50% - 10px);
}
.prod-icons-grid .prod-icon  .custom-control-label:after {
    top: auto;
    bottom: 10px;
    left: calc(50% - 10px);
}
.prod-icons-grid .custom-checkbox .custom-control-input:checked ~ .custom-control-label {
    background-color: #e9f5fe;
}
</style>
